import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedEnumify } from '@mews/framework';
import { ResourceCategoryType as ResourceCategoryTypeEnum } from '@mews-commander/data-access';
import { ResourceCategoryType } from '@mews-commander/legacy-data-structures';
import { ApplicationState } from '@mews-commander/types';
import { getCategoryResourceCategoryTypeById } from '../../../selectors/categories';

interface StateProps {
    resourceCategoryType: ResourceCategoryTypeEnum;
}

interface OwnProps {
    id: string;
    scope: string;
}

const CategoryType = ({ resourceCategoryType }: { resourceCategoryType: ResourceCategoryTypeEnum }) => (
    <LocalizedEnumify enumValue={ResourceCategoryType.getByName(resourceCategoryType)} />
);

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        resourceCategoryType: getCategoryResourceCategoryTypeById,
    })
)(CategoryType);
